import { render, staticRenderFns } from "./InviteRewardFlowManagement.vue?vue&type=template&id=3c8d745e&scoped=true"
import script from "./InviteRewardFlowManagement.vue?vue&type=script&lang=js"
export * from "./InviteRewardFlowManagement.vue?vue&type=script&lang=js"
import style0 from "./InviteRewardFlowManagement.vue?vue&type=style&index=0&id=3c8d745e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8d745e",
  null
  
)

export default component.exports